﻿import React from "react";
import './Key.css';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { KeyBlock } from 'components/key';
import { ShowHide } from 'components/layout';
import { GridLayout } from "components/grid";

export function Key(
    {
        items = [],
        loading = false,
        listVertical = false,
        listGrid = false,
        rounded = false,
        hasPadding = true,
        useIconColour = false,
        listGridColumns
    }
) {
    function renderKeyContent() {
        return items && items.map(function (item) {
            // A swatch replaces the block outright, so the KeyBlock is only built when there is none.
            // Building both and choosing between them would construct a KeyBlock without the colours it
            // requires for every swatch-based item.
            let swatch;

            if (item.swatch != null) {
                swatch = item.swatch;
            } else {
                swatch = (
                    <KeyBlock className={item.className}
                        rounded={rounded}
                        colours={item.colours}
                        icon={item.icon}
                        iconColour={item.iconColour}
                        hideBorder={item.hideBorder}
                        useIconColor={useIconColour}
                    />
                );
            }

            return (
                <div key={item.name} className={classNames("key-wrapper", { "key-wrapper-described": item.description != null })}>
                    {swatch}
                    <ShowHide
                        evaluator={item.description != null}
                        show={(
                            <div className="key-text">
                                <div className="key-name">{item.name}</div>
                                <div className="key-description">{item.description}</div>
                            </div>
                        )}
                        hide={(<label>{item.name}</label>)}
                    />
                </div>
            );
        })
    }

    return listGrid 
        ? (
            <GridLayout numberOfColumns={listGridColumns}>
                {renderKeyContent()}
            </GridLayout>
        ) 
        : (
            <div className={
                classNames(
                    "listing-key", { 
                        "bp6-skeleton": loading, 
                        "vertical": listVertical, 
                        "listing-key-padding": hasPadding 
                    })}
                >
                {renderKeyContent()}
            </div>
        )
}

Key.propTypes = {
    items: PropTypes.array,
    loading: PropTypes.bool,
    listVertical: PropTypes.bool,
    listGrid: PropTypes.bool,
    listGridColumns: PropTypes.number,
    rounded: PropTypes.bool,
    hasPadding: PropTypes.bool,
    useIconColour: PropTypes.bool
};